module.exports = __webpack_public_path__ + "img/markerG.14e2f9ca.png";